export default "__VITE_ASSET__5efb9b07__"